module.exports = __webpack_public_path__ + "img/davich-symbol-motif@2x.407dae8d.png";